var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 20,
    viewBox: "0 0 8 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    d: "M15253.668,573v-1.333h2.666V573Zm0-2.665V569h2.666v1.333Zm0-2.665v-1.333h2.666v1.333Zm0-2.675.006-8.01-2.67-.007,3.986-3.978,4.014,4-2.6-.007v8Z",
    transform: "translate(-15251.004 -553)",
    fill: "#09bf28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.bb0a72cad11c140a56d6b97c5b044dbf.svg";
export { ForwardRef as ReactComponent };